import Phaser from 'phaser';

// Main game scene that handles the maze, player, and input
class MazeScene extends Phaser.Scene {
  constructor() {
    super('MazeScene');
  }

  /**
   * Creates a 2D maze using recursive backtracking.
   * 1 = wall, 0 = path
   */
  createMaze(rows, cols) { // Removed TypeScript type annotations
    // Initialize maze filled with walls
    const maze = Array(rows).fill(0).map(() => Array(cols).fill(1));
    const stack = []; // Removed TypeScript type annotation

    const visit = (x, y) => { // Removed TypeScript type annotations
      maze[y][x] = 0; // Mark the cell as path
      const dirs = [
        [0, -2], // Up
        [2, 0],  // Right
        [0, 2],  // Down
        [-2, 0], // Left
      ];
      Phaser.Utils.Array.Shuffle(dirs); // Randomize directions

      for (const [dx, dy] of dirs) {
        const nx = x + dx;
        const ny = y + dy;

        if (
          ny >= 0 && ny < rows &&
          nx >= 0 && nx < cols &&
          maze[ny][nx] === 1 // Unvisited
        ) {
          maze[y + dy / 2][x + dx / 2] = 0; // Knock down wall
          visit(nx, ny); // Recurse
        }
      }
    };

    visit(1, 1); // Start generation from (1,1)
    return maze;
  }

  preload() {}

  create() {
    const tileSize = 16;
    const maze = this.createMaze(21, 21); // Must be odd numbers for proper maze

    // Render maze tiles
    for (let y = 0; y < maze.length; y++) {
      for (let x = 0; x < maze[0].length; x++) {
        const color = maze[y][x] === 1 ? 0x222222 : 0xffffff; // Wall vs Path
        this.add.rectangle(x * tileSize, y * tileSize, tileSize, tileSize, color).setOrigin(0);
      }
    }

    // Add player sprite (green square)
    this.player = this.add.rectangle(16, 16, 12, 12, 0x00ff00).setOrigin(0);

    // Capture arrow key input
    this.cursors = this.input.keyboard.createCursorKeys();
  }

  update() {
    const speed = 2;
    if (this.cursors.left.isDown) this.player.x -= speed;
    else if (this.cursors.right.isDown) this.player.x += speed;
    if (this.cursors.up.isDown) this.player.y -= speed;
    else if (this.cursors.down.isDown) this.player.y += speed;
  }
}

export default MazeScene;